export const MAX_DIGITAL_PROPERTY_TAGS = 10;
export const MAX_DIGITAL_PROPERTY_TAG_CHAR_LENGTH = 255;
